module.exports = __webpack_public_path__ + "index/img/tixian.3b493b59.png";